var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12ZM5.99991 10.9091C8.71113 10.9091 10.909 8.71122 10.909 6C10.909 3.28878 8.71113 1.09091 5.99991 1.09091C3.2887 1.09091 1.09082 3.28878 1.09082 6C1.09082 8.71122 3.2887 10.9091 5.99991 10.9091ZM6.54558 8.72722V5.13497L7.79625 6.38564L8.56764 5.61425L6.00013 3.04674L3.43262 5.61425L4.20401 6.38564L5.45468 5.13497V8.72722H6.54558Z",
    fill: "#44AEB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.1dc89db7e35b720fcef159a81cf633da.svg";
export { ForwardRef as ReactComponent };